import React from "react";

import { TabProps as TabPropsMUI } from "@libraries/mui";

import * as Styled from "./styles";

const Step: React.FC<TabPropsMUI> = ({ ...rest }) => <Styled.Tab {...rest} />;

export default Step;
